var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('output-dialog',{ref:"printDlg",attrs:{"aspectRatio":849/1000,"background":require('@/assets/img/JpModel.jpg'),"fields":_vm.fields,"pages":_vm.pages,"filename":"JpModel.pdf","orientation":"portrait","title":"取引先用 登録用紙（日本語）"}})}
var staticRenderFns = []

export { render, staticRenderFns }